import React, { useEffect, lazy, Suspense } from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  useLocation,
} from "react-router-dom";

import LoginForm from "./components/LoginForm";
import LoginFormtest1 from "./components/LoginFormtest1";
import LoginFormtest2 from "./components/LoginFormtest2";
import LoginFormtest3 from "./components/LoginFormtest3";
import EmailClient from "./components/EmailClient";

import AdminPortal from "./components/AdminPortal";
import ClientSignup from "./components/ClientDashboard/SignUpForm/SignupPage/signup";
import ClientOtp from "./components/ClientDashboard/SignUpForm/SignupPage/otp";
import ProtectedRoute from "./components/ProtectedRoute";
import ClientProtectedRoute from "./components/ClientDashboard/SignUpForm/ClientProtectedRoute";
import OrganizationSetupForm from "./components/ClientDashboard/SignUpForm/ClientProfile/Setup";
import MainDashBoard from "./components/RFPDashboard/MainDashBoard";
import MapView from "./components/Cluster";
import Homepage from "./components/LandingPages/HomePage";
import Navbar from "./components/LandingPages/Component/Navbar";
import Footer from "./components/LandingPages/Component/Footer";
import VendorLandingPage from "./components/LandingPages/VendorLandingPage";
import IpLandingPage from "./components/LandingPages/IpLandingPage";
import ContactUsLandingPage from "./components/LandingPages/ContactUsLandingPage";
import DeleteAccountIp from "./components/LandingPages/DeleteAccountIp";
import MapChart from "./components/LandingPages/Component/MapCharts";
import Privacy from "./components/LandingPages/Component/Privacy";
import TermCondition from "./components/LandingPages/Component/TermCondition";
// import CheckDeviceAlert from "./components/checkDeviceAlert";
import SendOTP from "./components/LandingPages/Component/SendOTP";
import Birthday from "./components/LandingPages/Birthday";
import ThankyouPage from "./components/LandingPages/ThankyouPage";
import ReccepptModal from "./components/LandingPages/ReccepptModal";
// import AboutUs from "./components/LandingPages/Component/AboutUs/AboutUs";
import BlogDetails from "./components/LandingPages/Component/Blogs/BlogDetails";
import CircularProgress from "@mui/material/CircularProgress";

import VendorPortal from "./components/vendorWebFolder/VendorPortal";
import VendorPortalOTP from "./components/vendorWebFolder/VendorPortalOTP";
import VendorPortalLayout from "./components/vendorWebFolder/VendorPortalLayout";
import VendorRegister from "./components/vendorWebFolder/VendorRegister";
import VendorLayout from "./components/vendorWebFolder/VendorLayout";
import VendorProfile from "./components/vendorWebFolder/vendorProfile/VendorProfile";
import VendorProtectedRoute from "./components/vendorWebFolder/helperFunctions/VendorProtectedRoute";
import OngoingJobs from "./components/vendorWebFolder/jobs/OngoingJobs";
import Opprtunities from "./components/vendorWebFolder/jobs/Opprtunities";
import UpcomingJobs from "./components/vendorWebFolder/jobs/UpcomingJobs";
import CompletedJob from "./components/vendorWebFolder/jobs/CompletedJob";
import ThreeJsMain from "./ThreeJs/ThreeJsMain";

import VendorMoney from "./components/vendorWebFolder/vendorPayments/VendorMoney";
import VendorDashboard from "./components/vendorWebFolder/vendorDashboardComponents/VendorDashboard";
import ClusterDashboard from "./components/vendorWebFolder/jobs/ClusterDashboard";
import BlogLandingPage from "./components/LandingPages/Component/Blogs/BlogLandingPage";
import MaintenancePage from "./components/LandingPages/Maintanance";
import DragDrop from "./components/AdminportalFolder/DragDrop";
import ShortUrlRedirect from "./components/ShortUrlRedirect.js";

// Separate AppLayout Component
const AppLayout = () => {
  const Homepage = lazy(() => import("./components/LandingPages/HomePage"));

  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  // Paths where Navbar and Footer should be visible

  const exactPathsWithNavbar = [
    "/",
    // "/brand",
    "/vendor",
    "/ip",
    "/ContactUs",
    "/privacy",
    "/term&condition",
    "/aboutus",
    "/accountDelete",
    "/blogs",
  ];
  const prefixPathsWithNavbar = ["/blogs/"]; // paths that start with this

  const showNavbar =
    exactPathsWithNavbar.includes(pathname) ||
    prefixPathsWithNavbar.some((path) => pathname.startsWith(path));

  const exactPathsWithFooter = [
    "/",
    // "/brand",

    "/vendor",
    "/ip",
  ];
  const prefixPathsWithFooter = ["/blogs/"];

  const showFooter =
    exactPathsWithFooter.includes(pathname) ||
    prefixPathsWithFooter.some((path) => pathname.startsWith(path));

  return (
    <>
      {/* <CheckDeviceAlert/> */}

      {/* Conditionally render Navbar and Footer */}
      {showNavbar && <Navbar />}

      {/* Routes */}
      <Routes>
        {/* <Route exact path="/" element={<Homepage />} />
         */}
        <Route
          exact
          path="/"
          element={
            <Suspense
              fallback={
                <div className="flex justify-center items-center h-screen">
                  <CircularProgress />
                </div>
              }
            >
              <Homepage />
            </Suspense>
          }
        />
        {/* <Route
          exact
          path="/"
          element={
            <Suspense
              fallback={
                <div className="flex justify-center items-center h-screen">
                  <CircularProgress />
                </div>
              }
            >
              <MaintenancePage />
            </Suspense>
          }
        /> */}
        {/* <Route exact path="/brand" element={<BrandPage />} /> */}
        <Route exact path="/dragdrop" element={<DragDrop />} />
        <Route exact path="/vendor" element={<VendorLandingPage />} />
        <Route exact path="/ip" element={<IpLandingPage />} />
        <Route exact path="/blogs" element={<BlogLandingPage />} />
        <Route path="/blogs/:id" element={<BlogDetails />} />
        <Route exact path="/lottie" element={<Birthday />} />
        <Route exact path="/thanks" element={<ThankyouPage />} />
        <Route exact path="/3dOverview" element={<ThreeJsMain />} />
        <Route exact path="/ppt" element={<ReccepptModal />} />
        {/* <Route path="/adminportal" element={<LoginForm />} />
        <Route path="/adminportal" element={<LoginFormtest1 />} /> */}
        {/* <Route path="/adminportal" element={<LoginFormtest2 />} /> */}
        <Route path="/adminportal" element={<LoginFormtest3 />} />
        <Route path="/emailforclient" element={<EmailClient />} />
        <Route exact path="/ContactUs" element={<ContactUsLandingPage />} />
        <Route exact path="/accountDelete" element={<DeleteAccountIp />} />
        <Route exact path="/privacy" element={<Privacy />} />
        <Route exact path="/term&condition" element={<TermCondition />} />
        {/* <Route exact path="/aboutus" element={<AboutUs />} /> */}
        <Route path="/map" element={<MapChart />} />
        <Route path="/sendOTP" element={<SendOTP />} />
        {/* all routes related to the vendorportal */}
        <Route path="/vendorportal" element={<VendorPortalLayout />}>
          <Route index element={<VendorPortal />} />
          <Route path="otp" element={<VendorPortalOTP />} />

          {/* Protected Routes */}
          <Route element={<VendorProtectedRoute />}>
            <Route path="register" element={<VendorRegister />} />
            <Route element={<VendorLayout />}>
              <Route path="dashboard" element={<VendorDashboard />} />
              <Route path="profile" element={<VendorProfile />} />
              <Route path="jobs/ongoing" element={<OngoingJobs />} />
              <Route path="jobs/opportunities" element={<Opprtunities />} />
              <Route path="jobs/upcoming" element={<UpcomingJobs />} />
              <Route path="jobs/completed" element={<CompletedJob />} />
              <Route path="jobs/cluster" element={<ClusterDashboard />} />
              <Route path="money" element={<VendorMoney />} />
            </Route>
          </Route>
        </Route>
        <Route
          path="/adminportal/*"
          element={
            <ProtectedRoute>
              <AdminPortal />
            </ProtectedRoute>
          }
        />
        <Route path="/user" element={<ClientSignup />} />
        <Route path="/user/otp" element={<ClientOtp />} />
        <Route path="/user/profile" element={<OrganizationSetupForm />} />
        <Route
          path="/user/*"
          element={
            <ClientProtectedRoute>
              <MainDashBoard />
            </ClientProtectedRoute>
          }
        />
        <Route path="/clusters" element={<MapView />} />
        // route for the short URL
        <Route path="/:shortCode" element={<ShortUrlRedirect />} />
      </Routes>

      {showFooter && <Footer />}
    </>
  );
};

// Main App Component
function App() {
  return (
    <Router>
      <AppLayout />
    </Router>
  );
}

export default App;
